import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { Box } from '@mui/material';
import { SequencingWizardContext } from '../../SequencingWizardContext';
import ProductCheckboxList from '../../components/ProductCheckboxList.connector';
import Buttons from '../../components/Buttons';
import SummaryDrawer from '../../components/SummaryDrawer';

const RemoveStep2 = props => {
  const { next, prev } = props;
  const {
    data: { products = [] },
    setData,
  } = useContext(SequencingWizardContext);

  const continueDisabled = R.isEmpty(products);

  const handleChange = R.o(setData, R.assoc('products'));

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 203px
          // prevents progress bar from looking off
          height: 'calc(100% - 203px)',
          mb: '46px',
          overflowY: 'auto',
        }}
      >
        <Box flexGrow={1}>
          <ProductCheckboxList onChange={handleChange} title="Select one or more products" />
        </Box>
        <SummaryDrawer inventoryOwnerSubtitle="Selected Inventory Owner" />
      </Box>
      <Buttons
        disabled={continueDisabled}
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        rightLabel="Continue"
      />
    </>
  );
};

RemoveStep2.propTypes = {
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};

export default RemoveStep2;
